export default __webpack_public_path__ + "assets/icon-receipt-long-yellow.717c5bad.webp";